import { Component, OnInit } from '@angular/core';
import { MedicalCenter } from '../../../models/medical-center.model';
import { MedicalCenterService } from '../../../services/medical-center.service';
import { ExportService } from '../../../services/export.service';

@Component({
  selector: 'app-medical-center-export',
  templateUrl: './medical-center-export.component.html'
})
export class MedicalCenterExportComponent implements OnInit {

  medicalCenter: MedicalCenter;

  constructor(
    private medicalCenterService: MedicalCenterService,
    private exportService: ExportService
  ) {
    this.medicalCenterService.getCurrentCenter().subscribe(res => {
      this.medicalCenter = res;
    });
  }

  ngOnInit() {
  }

  exportCenter() {
    this.exportService.export({
      name: 'EXPORT_V0_BY_CENTRE'
    });
  }

}
